import {
  Table,
  TableContainer,
  Tbody,
  Text,
  Th,
  Thead,
  Tr
} from '@chakra-ui/react'
import type { VehiclesIdentificationDto, VehicleValuationDto } from 'BrokerTsLib/src/dtos'
import { useState } from 'react'

import { useVehicleValuation } from '../../../../../../../hooks/useVehicle'
import { VehiclePriceTableRow } from './VehiclePriceTableRow'

export interface VehiclePriceTableProps {
  vehicleIdentificationData: VehiclesIdentificationDto
  onUsePriceButtonClick: (usedPrice: number, withTax: boolean) => void
  paramsId?: string,
  licensePlate?: string | null,
  vin?: string | null,
  firstRegistrationDate: Date,
  mileage: number
}

export const VehiclePriceTable = (props: VehiclePriceTableProps) => {

  const {
    vehicleIdentificationData,
    onUsePriceButtonClick,
    paramsId,
    licensePlate,
    vin,
    firstRegistrationDate,
    mileage
  } = props

  // const [vehicleValuation, setVehicleValuation] = useState<VehicleValuationDto | null>(null);
  const { mutateAsync: refetchValuation, isLoading: isLoadingValuation } = useVehicleValuation()
  // const valuationError = !!valuationData[index]?.error

  const [activeIndex, setActiveIndex] = useState<number | null>(null)
  const [valuationData, setValuationData] = useState<{ [key: number]: VehicleValuationDto | null }>({})

  return (
    <TableContainer sx={{ w: '100%', fontSize: 'sm' }}>
      <Table>
        <Thead>
          <Tr>
            <Th>
              <Text>Značka</Text>
              <Text>Model</Text>
            </Th>
            <Th>
              <Text>Prodej od</Text>
              <Text>Prodej do</Text>
            </Th>
            <Th colSpan={2}>
              <Text>Cena nového s DPH</Text>
            </Th>
          </Tr>
        </Thead>

        <Tbody>
          {vehicleIdentificationData.vehicles
            ?.filter((u, i) => i < 15)
            .map((vehicle, index) => <VehiclePriceTableRow key={index} tableProps={props} vehicle={vehicle} />)}
        </Tbody>
      </Table>
    </TableContainer>
  )
}
